import { useEffect, useState } from 'react'
import type { AddressBookEntry, AddressSeedProfile } from './addressBookHelpers'
import {
  buildSeedAddressBook,
  readAddressBookFromStorage,
  writeAddressBookToStorage,
} from './addressBookHelpers'

type UseAddressBookPersistenceInput = {
  storageKey: string
  seedProfile: AddressSeedProfile
  countryFallback: string
}

export const useAddressBookPersistence = ({
  storageKey,
  seedProfile,
  countryFallback,
}: UseAddressBookPersistenceInput) => {
  const [addressBook, setAddressBook] = useState<AddressBookEntry[]>([])

  useEffect(() => {
    const saved = readAddressBookFromStorage(storageKey)
    if (saved.length > 0) {
      setAddressBook(saved)
      return
    }

    const seeded = buildSeedAddressBook(seedProfile, countryFallback)
    setAddressBook(seeded)
  }, [countryFallback, seedProfile, storageKey])

  useEffect(() => {
    writeAddressBookToStorage(storageKey, addressBook)
  }, [addressBook, storageKey])

  return {
    addressBook,
    setAddressBook,
  }
}
